// removed by extract-text-webpack-plugin
module.exports = {"featuredProductsHeader":"qempo_ProductsCommon_featuredProductsHeader-sMSZc9C","top":"qempo_ProductsCommon_top-2kvhaKM","grey":"qempo_ProductsCommon_grey-ioGTi-I","bottom":"qempo_ProductsCommon_bottom-1h5zvuy","mainWrap":"qempo_ProductsCommon_mainWrap-27s3Q40","rightWrap":"qempo_ProductsCommon_rightWrap-1kEn0Ib","noResults":"qempo_ProductsCommon_noResults-fvKuE1s","loading":"qempo_ProductsCommon_loading-2qTRjcb"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/featured-products/components/ProductsCommon.scss
// module id = 700
// module chunks = 0